import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { I18N_NAMESPACES } from './namespaces';

import skCommon from './locales/sk/common.json';
import skNavigation from './locales/sk/navigation.json';
import skAuth from './locales/sk/auth.json';
import skRegister from './locales/sk/register.json';
import skDashboard from './locales/sk/dashboard.json';
import skCustomers from './locales/sk/customers.json';
import skCustomerInvitations from './locales/sk/customerInvitations.json';
import skTenants from './locales/sk/tenants.json';
import skSupport from './locales/sk/support.json';
import skBilling from './locales/sk/billing.json';
import skPricing from './locales/sk/pricing.json';
import skStripe from './locales/sk/stripe.json';
import skNotifications from './locales/sk/notifications.json';
import skProviders from './locales/sk/providers.json';
import skStorage from './locales/sk/storage.json';
import skDataLifecycle from './locales/sk/dataLifecycle.json';
import skFeatures from './locales/sk/features.json';
import skTenantAccess from './locales/sk/tenantAccess.json';
import skSetupWizard from './locales/sk/setupWizard.json';
import skTenantProvisioning from './locales/sk/tenantProvisioning.json';
import skTenantSchema from './locales/sk/tenantSchema.json';
import skTenantSchemaRunner from './locales/sk/tenantSchemaRunner.json';
import skOnboarding from './locales/sk/onboarding.json';
import skStatuses from './locales/sk/statuses.json';
import skValidation from './locales/sk/validation.json';
import skSettings from './locales/sk/settings.json';
import skMafertappModules from './locales/sk/mafertappModules.json';
import skSubscriptionChanges from './locales/sk/subscriptionChanges.json';
import skModuleAccessEvents from './locales/sk/moduleAccessEvents.json';
import skPermissionCleanup from './locales/sk/permissionCleanup.json';
import skPermissions from './locales/sk/permissions.json';
import skSetupProfiles from './locales/sk/setupProfiles.json';
import skLaunchReadiness from './locales/sk/launchReadiness.json';
import skCustomerPortal from './locales/sk/customerPortal.json';
import skSystemLabels from './locales/sk/systemLabels.json';

import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enRegister from './locales/en/register.json';
import enDashboard from './locales/en/dashboard.json';
import enCustomers from './locales/en/customers.json';
import enCustomerInvitations from './locales/en/customerInvitations.json';
import enTenants from './locales/en/tenants.json';
import enSupport from './locales/en/support.json';
import enBilling from './locales/en/billing.json';
import enPricing from './locales/en/pricing.json';
import enStripe from './locales/en/stripe.json';
import enNotifications from './locales/en/notifications.json';
import enProviders from './locales/en/providers.json';
import enStorage from './locales/en/storage.json';
import enDataLifecycle from './locales/en/dataLifecycle.json';
import enFeatures from './locales/en/features.json';
import enTenantAccess from './locales/en/tenantAccess.json';
import enSetupWizard from './locales/en/setupWizard.json';
import enTenantProvisioning from './locales/en/tenantProvisioning.json';
import enTenantSchema from './locales/en/tenantSchema.json';
import enTenantSchemaRunner from './locales/en/tenantSchemaRunner.json';
import enOnboarding from './locales/en/onboarding.json';
import enStatuses from './locales/en/statuses.json';
import enValidation from './locales/en/validation.json';
import enSettings from './locales/en/settings.json';
import enMafertappModules from './locales/en/mafertappModules.json';
import enSubscriptionChanges from './locales/en/subscriptionChanges.json';
import enModuleAccessEvents from './locales/en/moduleAccessEvents.json';
import enPermissionCleanup from './locales/en/permissionCleanup.json';
import enPermissions from './locales/en/permissions.json';
import enSetupProfiles from './locales/en/setupProfiles.json';
import enLaunchReadiness from './locales/en/launchReadiness.json';
import enCustomerPortal from './locales/en/customerPortal.json';
import enSystemLabels from './locales/en/systemLabels.json';

import deCommon from './locales/de/common.json';
import deNavigation from './locales/de/navigation.json';
import deAuth from './locales/de/auth.json';
import deRegister from './locales/de/register.json';
import deDashboard from './locales/de/dashboard.json';
import deCustomers from './locales/de/customers.json';
import deCustomerInvitations from './locales/de/customerInvitations.json';
import deTenants from './locales/de/tenants.json';
import deSupport from './locales/de/support.json';
import deBilling from './locales/de/billing.json';
import dePricing from './locales/de/pricing.json';
import deStripe from './locales/de/stripe.json';
import deNotifications from './locales/de/notifications.json';
import deProviders from './locales/de/providers.json';
import deStorage from './locales/de/storage.json';
import deDataLifecycle from './locales/de/dataLifecycle.json';
import deFeatures from './locales/de/features.json';
import deTenantAccess from './locales/de/tenantAccess.json';
import deSetupWizard from './locales/de/setupWizard.json';
import deTenantProvisioning from './locales/de/tenantProvisioning.json';
import deTenantSchema from './locales/de/tenantSchema.json';
import deTenantSchemaRunner from './locales/de/tenantSchemaRunner.json';
import deOnboarding from './locales/de/onboarding.json';
import deStatuses from './locales/de/statuses.json';
import deValidation from './locales/de/validation.json';
import deSettings from './locales/de/settings.json';
import deMafertappModules from './locales/de/mafertappModules.json';
import deSubscriptionChanges from './locales/de/subscriptionChanges.json';
import deModuleAccessEvents from './locales/de/moduleAccessEvents.json';
import dePermissionCleanup from './locales/de/permissionCleanup.json';
import dePermissions from './locales/de/permissions.json';
import deSetupProfiles from './locales/de/setupProfiles.json';
import deLaunchReadiness from './locales/de/launchReadiness.json';
import deCustomerPortal from './locales/de/customerPortal.json';
import deSystemLabels from './locales/de/systemLabels.json';

export const LOCALE_STORAGE_KEY = 'mafert_system_locale';
export const SUPPORTED_LOCALES = ['sk', 'en', 'de'];
export const DEFAULT_LOCALE = 'sk';

function detectBrowserLocale() {
  const browser = (navigator.language || 'sk').toLowerCase().split('-')[0];
  return SUPPORTED_LOCALES.includes(browser) ? browser : DEFAULT_LOCALE;
}

export function resolveInitialLocale(userLocale) {
  if (userLocale && SUPPORTED_LOCALES.includes(userLocale)) {
    return userLocale;
  }

  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && SUPPORTED_LOCALES.includes(stored)) {
    return stored;
  }

  return detectBrowserLocale();
}

const resources = {
  sk: {
    common: skCommon,
    navigation: skNavigation,
    auth: skAuth,
    register: skRegister,
    dashboard: skDashboard,
    customers: skCustomers,
    customerInvitations: skCustomerInvitations,
    tenants: skTenants,
    support: skSupport,
    billing: skBilling,
    pricing: skPricing,
    stripe: skStripe,
    notifications: skNotifications,
    providers: skProviders,
    storage: skStorage,
    dataLifecycle: skDataLifecycle,
    features: skFeatures,
    tenantAccess: skTenantAccess,
    setupWizard: skSetupWizard,
    tenantProvisioning: skTenantProvisioning,
    tenantSchema: skTenantSchema,
    tenantSchemaRunner: skTenantSchemaRunner,
    onboarding: skOnboarding,
    statuses: skStatuses,
    status: skStatuses,
    validation: skValidation,
    settings: skSettings,
    mafertappModules: skMafertappModules,
    subscriptionChanges: skSubscriptionChanges,
    moduleAccessEvents: skModuleAccessEvents,
    permissionCleanup: skPermissionCleanup,
    permissions: skPermissions,
    setupProfiles: skSetupProfiles,
    launchReadiness: skLaunchReadiness,
    customerPortal: skCustomerPortal,
    systemLabels: skSystemLabels,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    register: enRegister,
    dashboard: enDashboard,
    customers: enCustomers,
    customerInvitations: enCustomerInvitations,
    tenants: enTenants,
    support: enSupport,
    billing: enBilling,
    pricing: enPricing,
    stripe: enStripe,
    notifications: enNotifications,
    providers: enProviders,
    storage: enStorage,
    dataLifecycle: enDataLifecycle,
    features: enFeatures,
    tenantAccess: enTenantAccess,
    setupWizard: enSetupWizard,
    tenantProvisioning: enTenantProvisioning,
    tenantSchema: enTenantSchema,
    tenantSchemaRunner: enTenantSchemaRunner,
    onboarding: enOnboarding,
    statuses: enStatuses,
    status: enStatuses,
    validation: enValidation,
    settings: enSettings,
    mafertappModules: enMafertappModules,
    subscriptionChanges: enSubscriptionChanges,
    moduleAccessEvents: enModuleAccessEvents,
    permissionCleanup: enPermissionCleanup,
    permissions: enPermissions,
    setupProfiles: enSetupProfiles,
    launchReadiness: enLaunchReadiness,
    customerPortal: enCustomerPortal,
    systemLabels: enSystemLabels,
  },
  de: {
    common: deCommon,
    navigation: deNavigation,
    auth: deAuth,
    register: deRegister,
    dashboard: deDashboard,
    customers: deCustomers,
    customerInvitations: deCustomerInvitations,
    tenants: deTenants,
    support: deSupport,
    billing: deBilling,
    pricing: dePricing,
    stripe: deStripe,
    notifications: deNotifications,
    providers: deProviders,
    storage: deStorage,
    dataLifecycle: deDataLifecycle,
    features: deFeatures,
    tenantAccess: deTenantAccess,
    setupWizard: deSetupWizard,
    tenantProvisioning: deTenantProvisioning,
    tenantSchema: deTenantSchema,
    tenantSchemaRunner: deTenantSchemaRunner,
    onboarding: deOnboarding,
    statuses: deStatuses,
    status: deStatuses,
    validation: deValidation,
    settings: deSettings,
    mafertappModules: deMafertappModules,
    subscriptionChanges: deSubscriptionChanges,
    moduleAccessEvents: deModuleAccessEvents,
    permissionCleanup: dePermissionCleanup,
    permissions: dePermissions,
    setupProfiles: deSetupProfiles,
    launchReadiness: deLaunchReadiness,
    customerPortal: deCustomerPortal,
    systemLabels: deSystemLabels,
  },
};

const allNamespaces = [...I18N_NAMESPACES, 'status'];

i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: allNamespaces,
  interpolation: { escapeValue: false },
  returnNull: false,
  parseMissingKeyHandler: (key) => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(`[i18n] Missing translation key: ${key}`);
    }
    return key;
  },
});

export function setAppLocale(locale, { persist = true } = {}) {
  const normalized = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  i18n.changeLanguage(normalized);

  if (persist) {
    localStorage.setItem(LOCALE_STORAGE_KEY, normalized);
  }

  return normalized;
}

export default i18n;
